import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import DImage from "../../components/DImage";
import DCard from "../../components/DCard";
import productServices from "../../services/products";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import { availableSorrundWithButton } from "../../utils/functions";
import DButton from "../../components/DButton";
import DModal from "../../components/DModal";
import { useDisclosure } from "@chakra-ui/react";
import { toast } from "react-hot-toast";

const columns = [
  { Header: "معرف المنتج", accessor: "id" },
  { Header: "الاسم", accessor: "name" },
  { Header: "الصورة", accessor: "img" },
  { Header: "الحد الأدنلى ", accessor: "qty_min" },
  { Header: "الحد الأعلى", accessor: "qty_max" },
  { Header: "متاح", accessor: "is_available" },
  { Header: "التحكم", accessor: "actions" },
];
const SubProducts = ({ title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentPage, setCurrentPage] = useState(0);
  const [currentProduct, setCurrentProduct] = useState();
  const queryClient = useQueryClient();
  const { id } = useParams();
  const { data, isLoading, error } = useQuery(["getSubProducts", id], () =>
    productServices.getSubProducts(id, currentPage + 1)
  );

  const navigate = useNavigate();

  const formattedData = (data) => {
    if (data?.length > 0) {
      return data.map((d) => ({
        id: d.id,
        name: d.name,
        qty_min: d.qty_min,
        qty_max: d.qty_max,

        img: d.img ? (
          <div className="relative max-w-[100px] mx-auto">
            <DImage src={d.img} alt={d.img} load={true} />
          </div>
        ) : (
          "------"
        ),
        is_available: d.is_available === 1 ? "متاح" : "غير متاح",
        actions: (
          <div className="flex items-center justify-center gap-2">
            <DButton
              bgColor="primary"
              className={"text-white min-w-[75px] rounded-[50px_!important]"}
              onClick={() => navigate(`/subitems/${d.id}/custom-prices`)}
            >
              السعر المخصص
            </DButton>
            <DButton
              bgColor="success"
              className={"text-white min-w-[75px] rounded-[50px_!important]"}
              onClick={() => navigate(`/products/${id}/sub-product/${d.id}`)}
            >
              تعديل
            </DButton>
            <DButton
              bgColor="danger"
              className={"text-white min-w-[75px] rounded-[50px_!important]"}
              onClick={() => {
                onOpen();
                setCurrentProduct(d.id);
              }}
            >
              حذف
            </DButton>
          </div>
        ),
      }));
    }
    return [];
  };

  const deleteSubProduct = () => {
    onClose();
    productServices
      .deleteSubProduct(currentProduct)
      .then((res) => {
        toast.success("تم الحذف بنجاح");
        queryClient.refetchQueries(["getSubProducts"]);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("المنتج غير موجود");
        } else {
          toast.error("حصل خطأ ما");
        }
      });
  };

  if (error || isNaN(Number(id)) || !id) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DModal
        isOpen={isOpen}
        onClose={onClose}
        modelType="delete"
        clickHandler={deleteSubProduct}
        bodyText="عند حذفك لهذا السجل قد يتم حذف سجلات مرتبطة به مثل
                        عمليات الطلب"
      />
      <DCard className={`${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalData={data.data.total}
            head={columns}
            elements={{
              is_available: availableSorrundWithButton,
            }}
            body={formattedData(data.data.data)}
          />
        )}
      </DCard>
    </div>
  );
};

export default SubProducts;
